import { LRParser } from "@lezer/lr"
import { NodeProp } from "@lezer/common"
import { LRLanguage, LanguageSupport } from "@codemirror/language"

// This was generated using the lezer-generator CLI
// lezer-generator file -o output-file
// I just copied over output file and read the lang-html package
// to figure out how to wire it up with codemirror
// I only generated the liquid.grammar.
// Todo: figure out how liquid-tag.gammar works and liquid-variable.gammar

export const parser = LRParser.deserialize({
  version: 13,
  states:
    "$hQQOPOOOOOO'#C^'#C^OcOQO'#CaOqOSO'#CcOyOWO'#CgOOOO'#Cn'#CnOOOO'#Ci'#CiQQOPOOOOOO'#Cr'#CrOOOO'#Cq'#CqOOOO'#Cj'#CjO!XOQO'#CbO!gOQO,58{OOOO'#Ck'#CkO!lOSO'#CdO!tOSO,58}OOOO'#Cy'#CyOOOO'#Cl'#ClO!yOWO'#ChO#XOWO,59ROOOO-E6g-E6gOOOO-E6h-E6hOOOO1G.g1G.gOOOO-E6i-E6iOOOO1G.i1G.iOOOO-E6j-E6jOOOO1G.m1G.m",
  stateData:
    "#g~OSQOYSOcPOdPOkRO~OgWOhWOiXORUP~Ol]OjWP~OgWOhWOn`OX[P~OgWOhWOiXORUX~ORfO~Ol]OjWX~OjhO~OgWOhWOn`OX[X~OXjO~OSghdXnRi~",
  goto: "!znPPoPPosovPPoy|!S!Y!`P!fPP!j!nPPPPPP!vTTOVR[QR_RRcSQVORdVQZQReZQ^RRg^QbSRibTUOVTYQZSXQZT`SbTaSb",
  nodeNames:
    "⚠ LiquidDocument PlainText CloseVariable OpenVariable Variable VariableContents RawTag RawTagContents CloseTag OpenTag Tag TagContents",
  maxTerm: 30,
  nodeProps: [
    [NodeProp.openedBy, 3, "OpenVariable", 9, "OpenTag"],
    [NodeProp.closedBy, 4, "CloseVariable", 10, "CloseTag"],
  ],
  skippedNodes: [0],
  repeatNodeCount: 4,
  tokenData:
    "6t_R]OYzYZzZrzrs&wsuzuv)hvwzwx*mx#oz#o#p-^#p#qz#q#r5Q#r~z_!VZcPlSnWiQOr!xrs#tsu!xuv$Pvw!xwx#tx#o!x#o#p%U#p#q!x#q#r&T#r~!xZ#RZcPnWiQOr!xrs#tsu!xuv$Pvw!xwx#tx#o!x#o#p%U#p#q!x#q#r&T#r~!xP#yQcPO#o#t#p~#tR$WXcPiQOr$Prs#tsw$Pwx#tx#o$P#o#p$s#p#q$P#q#r#t#r~$PQ$xSiQOr$ssw$sx#q$s#r~$sY%]VnWiQOr%Usu%Uuv$svw%Ux#q%U#q#r%r#r~%UW%wSnWOr%rsu%rvw%rx~%rX&[XcPnWOr&Trs#tsu&Tuv#tvw&Twx#tx#o&T#o#p%r#p~&T_'SVcPlSnWiQOr'irs(Ts#O'i#O#P(b#P#o'i#o#p(v#p~'iZ'nVcPOr'irs(Ts#O'i#O#P(b#P#o'i#o#p(v#p~'iZ([QcPgYO#o#t#p~#tZ(gTcPOY'iYZ#tZ#o'i#o#p(v#p~'iY(yTOr(vrs)Ys#O(v#O#P)_#P~(vY)_OgYY)bQOY(vZ~(v_)sXcPlSnWiQOr$Prs#tsw$Pwx#tx#o$P#o#p$s#p#q$P#q#r*`#r~$PX*gQcPXWO#o#t#p~#t_*xVcPlSnWiQOw+_wx+yx#O+_#O#P,W#P#o+_#o#p,l#p~+_Z+dVcPOw+_wx+yx#O+_#O#P,W#P#o+_#o#p,l#p~+_Z,QQcPhYO#o#t#p~#tZ,]TcPOY+_YZ#tZ#o+_#o#p,l#p~+_Y,oTOw,lwx-Ox#O,l#O#P-T#P~,lY-TOhYY-WQOY,lZ~,l_-iXlSdPnWiQOr%Usu%Uuv.Uvw%Ux#o%U#o#p4b#p#q%U#q#r%r#r~%UV.]WYPiQOr$ssw$sx#X$s#X#Y.u#Y#f$s#f#g2`#g#q$s#r~$sU.zUiQOr$ssw$sx#b$s#b#c/^#c#q$s#r~$sU/cUiQOr$ssw$sx#W$s#W#X/u#X#q$s#r~$sU/zUiQOr$ssw$sx#f$s#f#g0^#g#q$s#r~$sU0cUiQOr$ssw$sx#T$s#T#U0u#U#q$s#r~$sU0zUiQOr$ssw$sx#k$s#k#l1^#l#q$s#r~$sU1cUiQOr$ssu$suv1uvw$sx#q$s#r~$sU1zTiQOr$ssw$sx#q$s#q#r2Z#r~$sS2`OjSR2eUiQOr$ssw$sx#T$s#T#U2w#U#q$s#r~$sR2|UiQOr$ssw$sx#k$s#k#l3`#l#q$s#r~$sR3eUiQOr$ssu$suv3wvw$sx#q$s#r~$sR3|TiQOr$ssw$sx#q$s#q#r4]#r~$sP4bOkPZ4kVSPnWiQOr%Usu%Uuv$svw%Ux#q%U#q#r%r#r~%U_5]ZcPlSnWiQOr&Trs#tsu&Tuv#tvw&Twx#tx#o&T#o#p%r#p#q&T#q#r6O#r~&TZ6XXcPnWRQOr&Trs#tsu&Tuv#tvw&Twx#tx#o&T#o#p%r#p~&T",
  tokenizers: [0, 1, 2, 3],
  topRules: { LiquidDocument: [0, 1] },
  tokenPrec: 106,
})

export const liquid = new LanguageSupport(
  LRLanguage.define({
    parser: parser.configure({}),
  })
)
